import { Breakpoints } from '@lg/shared'
import { LayoutService } from '../services/layout-service.js'
import { AppContext } from '../app-context.js'

export const FrontendLayoutBridge = new Proxy<Breakpoints>({} as any, {
	get(target, p, receiver) {
		const layoutService = AppContext.injector.get(LayoutService)
		const breakpoints = layoutService.breakpoints()
		return Reflect.get(breakpoints, p)
	},
	set() {
		return false
	},
	ownKeys(target) {
		const layoutService = AppContext.injector.get(LayoutService)
		const breakpoints = layoutService.breakpoints()
		return Reflect.ownKeys(breakpoints)
	},
})
